import React from "react"
import TeacherFormContainer from "../Container/TeacherFormContainer"
import { connect } from "react-redux"
import { updatePersonalDetails } from "../../redux/homePage/homePage.actions"
import { notify } from "react-notify-toast"
import { parseDate } from "../../Helper"
import UsiCheckForm from "./UsiCheckForm"

class UsiCheck extends React.Component {
  state = {
    usi_filename: this.props.user.usi_filename,
    usi_url: this.props.user.usi_url,
    usi_downloaded_date: parseDate(this.props.user.usi_downloaded_date),
    usi_status: this.props.user.usi_verification_status,
  }

  handleStateChange = (key, value) => {
    this.setState({ [key]: value })
  }

  handleFormFieldChange = (e) => {
    this.setState({ [e.target.id]: e.target.value })
  }

  handleDateChange = (date) => {
    this.setState({ usi_downloaded_date: date })
  }

  handleSubmit = (e) => {
    e.preventDefault()
    const fields = ["usi_downloaded_date"]
    let errors = false

    for (let field of fields) {
      const input = document.getElementById(field)
      if (!input.reportValidity()) {
        errors = true
        break;
      }
    }

    if (errors) {
      notify.hide();
      notify.show("You are missing one or more field(s)!")
      errors = true
    }

    if (!errors) {
      this.props.updatePersonalDetails({ ...this.state })
    }
  }

  getTabs = () => {
    const tabs = [
      {
        pathname: "/personalid",
        text: "Personal ID",
      },
      {
        pathname: "/visa",
        text: "Visa Details",
      },
      {
        pathname: "/policecheck",
        text: "Police Check (Opt.)",
      },
      {
        pathname: "/wwcc",
        text: "WWCC (Optional)",
      },
      {
        pathname: "/usiCheck",
        text: "USI Check (Opt.)",
        active: true,
      }
    ]

    if (this.props.user?.is_elt) {
      tabs.push({
        pathname: "/uploadPayLevel",
        text: "Pay Level Evidence",
      })
    }

    if (this.props.user?.is_childhood_teacher) {
      tabs.push({
        pathname: "/ececcheck",
        text: "First AID",
      });
    }

    return tabs
  }

  tabs = this.getTabs()

  render() {
    return (
      <div>
        <TeacherFormContainer
          header="Identification"
          tabs={this.tabs}
          handleSubmit={this.handleSubmit}
        >
          <UsiCheckForm
            handleStateChange={this.handleStateChange}
            handleFormFieldChange={this.handleFormFieldChange}
            handleDateChange={this.handleDateChange}
            state={this.state}
          />
        </TeacherFormContainer>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    user: state.user.user,
  }
}

const mapDispatchToProps = (dispatch) => ({
  updatePersonalDetails: (details) => dispatch(updatePersonalDetails(details)),
})

export default connect(mapStateToProps, mapDispatchToProps)(UsiCheck)
